import { render } from "./LoadingBlock.vue?vue&type=template&id=4ab6e018&scoped=true"
import script from "./LoadingBlock.vue?vue&type=script&lang=js"
export * from "./LoadingBlock.vue?vue&type=script&lang=js"

import "./LoadingBlock.vue?vue&type=style&index=0&id=4ab6e018&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab6e018"]])

export default __exports__